import { ComponentRef, Directive, ElementRef, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { DivPlaceholderComponent } from './div-placeholder/div-placeholder.component';

@Directive({
  selector: '[kzImgPlaceholder]'
})
export class ImgPlaceholderDirective {
  private _componentRef: ComponentRef<DivPlaceholderComponent>;

  @Input('kzImgPlaceholder')
  set isReady(isReady: boolean) {
    this.viewContainer.clear();
    if (isReady) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this._componentRef = this.viewContainer.createComponent(DivPlaceholderComponent);
    }
  }

  @Input() set kzImgPlaceholderShowLogo(show: boolean) {
    this._componentRef.instance.logo = show;
  }

  @Input() set kzImgPlaceholderShowProfile(show: boolean) {
    this._componentRef.instance.profile = show;
  }

  constructor(
      private readonly elementRef: ElementRef,
      private readonly templateRef: TemplateRef<any>,
      private readonly viewContainer: ViewContainerRef,
  ) {
  }

}
